/*
 * Copyright (c) 2025 by PROS, Inc.  All Rights Reserved.
 * This software is the confidential and proprietary information of
 * PROS, Inc. ("Confidential Information").
 * You may not disclose such Confidential Information, and may only
 * use such Confidential Information in accordance with the terms of
 * the license agreement you entered into with PROS.
 */
/**
 * Use this function in the default case of a switch to create an exhaustive switch case.
 *
 * @param value a value.
 */
export function unreacheable(value) {
    throw new Error(`Illegal State: Unexpected value: ${JSON.stringify(value)}`);
}
//# sourceMappingURL=unreacheable.js.map